export const validateValue = (value: string, decimalPlaces = 2) => {
    const regexp = new RegExp(`^(?!0[0-9])[0-9]+[.,]?[0-9]{0,${decimalPlaces}}$`, 'g');
    return (value?.match(regexp) && value.length <= 79) || !value.length;
};